export default __webpack_public_path__ + "ba26667adbb883169ae09c338dc8dfc7.png";